export const rankingTabs = [
  { key: "popular", label: "人气榜", valueLabel: "热度" },
  { key: "score", label: "评分榜", valueLabel: "评分" },
  { key: "expect", label: "期待榜", valueLabel: "期待值" },
];

export const rankingData = {
  popular: [
    { rank: 1, title: "鬼灭之刃 无限城篇", genre: "战斗 / 奇幻", value: "98.6", trend: "up" },
    { rank: 2, title: "咒术回战", genre: "战斗 / 超自然", value: "96.2", trend: "flat" },
    { rank: 3, title: "葬送的芙莉莲", genre: "奇幻 / 治愈", value: "94.8", trend: "up" },
    { rank: 4, title: "间谍过家家", genre: "日常 / 搞笑", value: "92.1", trend: "down" },
    { rank: 5, title: "我推的孩子", genre: "青春 / 悬疑", value: "90.7", trend: "up" },
    { rank: 6, title: "迷宫饭", genre: "奇幻 / 美食", value: "88.9", trend: "flat" },
    { rank: 7, title: "药屋少女的呢喃", genre: "古风 / 推理", value: "87.4", trend: "up" },
    { rank: 8, title: "蓝色监狱", genre: "运动 / 竞技", value: "85.3", trend: "down" },
    { rank: 9, title: "排球少年!!", genre: "运动 / 热血", value: "83.8", trend: "flat" },
    { rank: 10, title: "关于我转生变成史莱姆这档事", genre: "异世界 / 奇幻", value: "82.1", trend: "up" },
  ],
  score: [
    { rank: 1, title: "葬送的芙莉莲", genre: "奇幻 / 治愈", value: "9.4", trend: "flat" },
    { rank: 2, title: "孤独摇滚！", genre: "音乐 / 青春", value: "9.2", trend: "up" },
    { rank: 3, title: "紫罗兰永恒花园", genre: "治愈 / 剧情", value: "9.1", trend: "flat" },
    { rank: 4, title: "辉夜大小姐想让我告白", genre: "恋爱 / 搞笑", value: "9.0", trend: "down" },
    { rank: 5, title: "进击的巨人 最终季", genre: "暗黑 / 战斗", value: "9.0", trend: "flat" },
    { rank: 6, title: "灵能百分百", genre: "超能力 / 成长", value: "8.9", trend: "up" },
    { rank: 7, title: "强风吹拂", genre: "运动 / 青春", value: "8.9", trend: "flat" },
    { rank: 8, title: "夏目友人帐", genre: "治愈 / 妖怪", value: "8.8", trend: "down" },
    { rank: 9, title: "白色相簿2", genre: "恋爱 / 剧情", value: "8.7", trend: "flat" },
    { rank: 10, title: "冰菓", genre: "推理 / 青春", value: "8.6", trend: "up" },
  ],
  expect: [
    { rank: 1, title: "鬼灭之刃 无限城篇", genre: "战斗 / 奇幻", value: "99.1", trend: "up" },
    { rank: 2, title: "咒术回战 死灭回游", genre: "战斗 / 超自然", value: "97.5", trend: "up" },
    { rank: 3, title: "关于我转生变成史莱姆这档事", genre: "异世界 / 奇幻", value: "94.3", trend: "flat" },
    { rank: 4, title: "无职转生", genre: "异世界 / 成长", value: "93.0", trend: "up" },
    { rank: 5, title: "Re:从零开始的异世界生活", genre: "异世界 / 悬疑", value: "91.6", trend: "down" },
    { rank: 6, title: "我推的孩子 第三季", genre: "青春 / 悬疑", value: "90.2", trend: "up" },
    { rank: 7, title: "蓝色监狱 第二季", genre: "运动 / 竞技", value: "88.4", trend: "flat" },
    { rank: 8, title: "药屋少女的呢喃 第二季", genre: "古风 / 推理", value: "87.0", trend: "up" },
    { rank: 9, title: "地狱乐 第二季", genre: "暗黑 / 战斗", value: "85.5", trend: "flat" },
    { rank: 10, title: "孤独摇滚！第二季", genre: "音乐 / 青春", value: "84.1", trend: "up" },
  ],
};